import { IPersonalConsultation, ISpareParts } from "../../Interfaces/Appointments";
import { HTTPError } from "../../Exceptions/HTTPError";

const app_url = "/apps/rental-appointment/api";

const getFetchUrl = (type: string) => {
    return `${app_url}/submit-${type}-request`;
};

/**
 * Post request to the API
 *
 * @param {Object} body
 * @param {String} type
 * @return {Promise<JSON>}
 */
export const postRequest = async (body: IPersonalConsultation | ISpareParts, type: string): Promise<JSON> => {
    const response = await fetch(getFetchUrl(type), {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    });

    if (response.status !== 200) {
        throw new HTTPError(response.status, response.statusText);
    }

    return await response.json();
};
